import {FC} from 'react'
import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {checkIsActive, KTIcon} from '../../../../helpers'

type Props = {
  title:string,
  id: string,
  Func:any,
  Name:string
  icon?:string
  fontIcon?: string
  hasBullet?:boolean
}

const MenuItemTenantCTX: FC<Props> = ({title,Func,id,Name,icon,fontIcon,hasBullet=false}) => {
  const {pathname} = useLocation()

  return (
    <div className='menu-item me-lg-1' onClick={()=> Func(id,Name)}>
      <a
        className={clsx('menu-link py-3')}  
      > 
          {icon && (
            <span className='menu-icon'>
              <KTIcon iconName={icon} className='fs-2' />
            </span>
          )}
          {fontIcon && (
            <span className='menu-icon'>
              <i className={clsx('bi fs-3', fontIcon)}></i>
            </span>
          )}
          {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-title text-marino'>{title}</span>
      </a>
    </div>
  )
}

export {MenuItemTenantCTX}
